import { render, staticRenderFns } from "./IconChevronUpSolid.vue?vue&type=template&id=f5362f8a"
import script from "./IconChevronUpSolid.vue?vue&type=script&lang=js"
export * from "./IconChevronUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports